module.exports = __webpack_public_path__ + "static/img/b22.53f5b07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b22.jpg
// module id = Mkao
// module chunks = 1